import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Gift = function Gift(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M68.3332 75H11.6665V35H14.9998V71.6667H64.9998V35H68.3332V75Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M73.3333 36.6667H45V20H73.3333V36.6667ZM48.3333 33.3333H70V23.3333H48.3333V33.3333Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.9998 36.6667H6.6665V20H34.9998V36.6667ZM9.99984 33.3333H31.6665V23.3333H9.99984V33.3333Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.9998 21.6665H11.6665V12.5415C11.6665 10.479 12.5207 8.47903 14.0415 7.06236C15.4165 5.74986 17.3123 5.02069 19.2498 5.02069C21.2707 5.02069 23.1457 5.81236 24.5832 7.22903L34.5415 17.1665L32.1873 19.5207L22.229 9.58319C20.6665 8.02069 17.9165 8.02069 16.3332 9.49986C15.4998 10.2915 15.0207 11.3957 15.0207 12.5624V21.6665H14.9998Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M68.3337 21.6667H65.0003V12.5417C65.0003 11.3958 64.5212 10.2708 63.6878 9.47917C62.1253 8 59.3545 8 57.792 9.5625L47.8337 19.5L45.4795 17.1458L55.4378 7.20833C56.8545 5.79167 58.7503 5 60.7712 5C62.6878 5 64.5837 5.75 65.9795 7.04167C67.4795 8.45833 68.3545 10.4583 68.3545 12.5208V21.6667H68.3337Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M48.3332 75H31.6665V18.3333C31.6665 14.6667 34.6665 11.6667 38.3332 11.6667H41.6665C45.3332 11.6667 48.3332 14.6667 48.3332 18.3333V75ZM34.9998 71.6667H44.9998V18.3333C44.9998 16.5 43.4998 15 41.6665 15H38.3332C36.4998 15 34.9998 16.5 34.9998 18.3333V71.6667Z",
      fill: color
    })]
  });
};
export default Gift;